<script lang="ts">
	import { PUBLIC_STRAPI_MEDIA } from '$env/static/public'
	import ContactBanner from '$lib/components/returns/ContactBanner.svelte'
	import type { ReturnComponent } from '$lib/js/strapi/types'
	
	export let component: ReturnComponent
</script>

<div class="block">
	<div class="block__text">
		<h2 class="title">{component.title}</h2>
		<p>
			{component.description}
		</p>
		<div class="contact-banner">
			<ContactBanner contact={component.contact} />
		</div>
		<p>{@html component.additional_info}</p>
	</div>
	<div class="block__image">
		<img
			src="{PUBLIC_STRAPI_MEDIA}{component.image?.url}"
			title=""
			alt=""
			width="400px"
		/>
	</div>
</div>

<style lang="scss">
	.block {
		margin-bottom: 80px;

		@media (min-width: 769px) {
			display: flex;
			gap: 60px;
			justify-content: space-between;
		}

		@media (min-width: 1025px) {
			gap: 120px;
		}

		&__text {
			@media (min-width: 769px) {
				width: calc(70% - 70px);
			}

			@media (min-width: 1025px) {
				width: calc(70% - 120px);
			}

			.title {
				margin-bottom: 30px;
			}

			.contact-banner {
				margin: 25px 0;
			}
		}

		&__image {
			width: 30%;
			margin-top: 60px;

			@media (max-width: 768px) {
				display: none;
			}

			img {
				@media (min-width: 769px) {
					max-width: 100%;
				}
			}
		}
	}
</style>
